module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('em', [_vm._v("For my mother, who first suggested that I write a book, and my father, who later urged me to write another one.")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d6dd37b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 75
// module chunks = 0